/* eslint-disable */
import Storage from './storage';

export default class User extends Storage {
    constructor() {
        super('user')
    }
}
